var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h166v67H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "m9-18.4-.6-.6L6-16.6 3.6-19l-.6.6L5.4-16 3-13.6l.6.6L6-15.4 8.4-13l.6-.6L6.6-16Z",
    transform: "translate(-3 19)",
    fill: "#a6adb6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 19,
    y: 62,
    width: 86,
    height: 67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 103,
    y: 62,
    width: 86,
    height: 67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46",
    transform: "translate(-282 -1236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1236)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1250h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1250.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1258a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(304 1259)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1273h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1273.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1278)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(464 1281)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 10",
    transform: "translate(19 62)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1213"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -62)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1499",
    width: 74,
    height: 55,
    rx: 3,
    transform: "translate(25 66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1212",
    transform: "translate(-835 -1402)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(852 1432)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1503",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(871 1432)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(852 1416)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 45,
    height: 4,
    rx: 1,
    transform: "translate(852 1423)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1502",
    transform: "translate(852 1445)",
    fill: "#fff",
    stroke: "#8c939f",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 7,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 763",
    transform: "translate(900.5 1446)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M-1.875-1.875h9.75v9.75h-9.75Z",
    fill: "#a6adb6"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1213"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -62)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1499",
    width: 74,
    height: 55,
    rx: 3,
    transform: "translate(109 66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1212",
    transform: "translate(-751 -1402)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1501",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(852 1432)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1503",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(871 1432)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 53,
    height: 4,
    rx: 1,
    transform: "translate(852 1416)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24",
    width: 45,
    height: 4,
    rx: 1,
    transform: "translate(852 1423)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1502",
    transform: "translate(852 1445)",
    fill: "#fff",
    stroke: "#8c939f",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 7,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 763",
    transform: "translate(900.5 1446)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M-1.875-1.875h9.75v9.75h-9.75Z",
    fill: "#a6adb6"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1214",
    transform: "translate(202.064 87)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 26,
    height: 16,
    rx: 3,
    transform: "translate(-.064)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.936 10)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Apply")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#eaeaea",
    d: "M24 130h220v16H24z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 11",
    transform: "translate(103 136)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1216"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1504",
    fill: "#fff",
    d: "M24 147h220v66H24z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 145",
    d: "m33.487 203.723 32.6-31.406 43.363 10.467 23.734-14.153 26.8 10.309 29.372-10.309 16.732 3.686 19.652-10.35h8.283",
    fill: "none",
    stroke: "#fd0826",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "m234.033 174.647-29.182-7.288-28.426 19.564-42.876 6.232-53.729-25.8-27.03 25.8-18.461 10.786",
    fill: "none",
    stroke: "#ffc1c8",
    strokeWidth: 2
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1218",
    transform: "translate(-816 -1336)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1505",
    fill: "#fff",
    d: "M840 1555h108v23H840z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1506",
    width: 84,
    height: 6,
    rx: 1,
    transform: "translate(852 1564)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    fill: "none",
    stroke: "#fd0826",
    d: "M840.5 1578.5H948"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1219",
    transform: "translate(-704 -1336)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1505",
    fill: "#fff",
    d: "M840 1555h108v23H840z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1506",
    width: 84,
    height: 6,
    rx: 1,
    transform: "translate(852 1564)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    fill: "none",
    stroke: "#ffc1c8",
    d: "M840.5 1578.5H948"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioAnalysis);
export default __webpack_public_path__ + "static/media/portfolio-analysis.64f650850ad8cff1e536a021fe772f91.svg";
export { ForwardRef as ReactComponent };